import api from './api/axiosConfig';
import { MOSQUE_BOOLEAN_FORM_KEYS } from '../utils/mosqueFeatures';

const appendMosqueFormField = (formData, key, val) => {
  if (val === undefined || val === null || val === '') return;
  if (key === 'display_image_index' && val !== undefined && val !== null) {
    formData.append(key, String(val));
    return;
  }
  if (key === 'prayer_timings_board' && val && typeof val === 'object') {
    formData.append(key, JSON.stringify(val));
    return;
  }
  formData.append(key, val);
};

const mosqueService = {
  // Get all mosques with optional filters
  getMosques: async (params = {}) => {
    try {
      const response = await api.get('/mosques/api/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching mosques:', error);
      throw error;
    }
  },

  // Get a single mosque by ID
  getMosque: async (id) => {
    try {
      const response = await api.get(`/mosques/api/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching mosque:', error);
      throw error;
    }
  },

  // Create a new mosque
  createMosque: async (mosqueData) => {
    try {
      const formData = new FormData();

      Object.keys(mosqueData).forEach((key) => {
        if (key === 'images' && Array.isArray(mosqueData.images)) {
          mosqueData.images.forEach((image) => {
            formData.append('images', image);
          });
          return;
        }
        if (key === 'images') return;
        const val = mosqueData[key];
        if (MOSQUE_BOOLEAN_FORM_KEYS.has(key)) {
          formData.append(key, val ? 'true' : 'false');
          return;
        }
        appendMosqueFormField(formData, key, val);
      });

      const response = await api.post('/mosques/api/', formData);
      return response.data;
    } catch (error) {
      console.error('Error creating mosque:', error);
      throw error;
    }
  },

  // Update a mosque
  updateMosque: async (id, mosqueData) => {
    try {
      const formData = new FormData();

      Object.keys(mosqueData).forEach((key) => {
        if (key === 'images' && Array.isArray(mosqueData.images)) {
          mosqueData.images.forEach((image) => {
            formData.append('images', image);
          });
          return;
        }
        if (key === 'images') return;
        const val = mosqueData[key];
        if (MOSQUE_BOOLEAN_FORM_KEYS.has(key)) {
          formData.append(key, val ? 'true' : 'false');
          return;
        }
        appendMosqueFormField(formData, key, val);
      });

      const response = await api.put(`/mosques/api/${id}/`, formData);
      return response.data;
    } catch (error) {
      console.error('Error updating mosque:', error);
      throw error;
    }
  },

  updatePrayerTimings: async (id, board) => {
    try {
      const response = await api.put(`/mosques/api/${id}/prayer-timings/`, board);
      return response.data;
    } catch (error) {
      console.error('Error updating prayer timings:', error);
      throw error;
    }
  },

  // Delete a mosque
  deleteMosque: async (id) => {
    try {
      const response = await api.delete(`/mosques/api/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting mosque:', error);
      throw error;
    }
  },

  // Get related mosques
  getRelatedMosques: async (mosqueId, params = {}) => {
    try {
      const response = await api.get('/mosques/api/', { 
        params: {
          ...params,
          exclude: mosqueId,
          limit: 4
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching related mosques:', error);
      throw error;
    }
  },
};

export default mosqueService;
